import { createFileRoute } from '@tanstack/react-router'
import { z } from 'zod'
import { AdminMonitoringHealthPage } from '~/features/admin-radar-operations/components'
import {
  adminMonitoringFixturesQueryOptions,
  adminMonitoringSummaryQueryOptions,
  adminMonitoringUnavailableQueryOptions,
} from '~/features/admin-radar-operations/query-options'

const monitoringSearchSchema = z.object({
  competitionCode: z.string().trim().min(1).optional(),
  season: z.coerce.number().int().positive().optional(),
})

export const Route = createFileRoute('/admin/monitoring')({
  validateSearch: monitoringSearchSchema,
  loaderDeps: ({ search: { competitionCode, season } }) => ({ competitionCode, season }),
  loader: async ({ context, deps: { competitionCode, season } }) => {
    const filter = competitionCode && season ? { competitionCode, season } : {}
    await Promise.all([
      context.queryClient.prefetchQuery(adminMonitoringSummaryQueryOptions(filter)),
      context.queryClient.prefetchQuery(adminMonitoringFixturesQueryOptions(filter)),
      context.queryClient.prefetchQuery(adminMonitoringUnavailableQueryOptions(filter)),
    ])
  },
  component: AdminMonitoringHealthPage,
})
